<template>
    <b-row id="commissions_total_component"
           class="commissions_total_component">
        <b-col lg="3" cols="6">
            <div class="commissions-total-label">
                <p>My frontliners:</p>
            </div>
            <div class="commissions-total-value">
                <p>{{ frontliners }}</p>
            </div>
        </b-col>
        <b-col lg="4" cols="6">
            <div class="commissions-total-label">
                <p>My unilevel team:</p>
            </div>
            <div class="commissions-total-value">
                <p>{{ tenLevelTeam }}</p>
            </div>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        computed: {
            frontliners () {
                return this.$store.getters.user.frontliners
            },
            tenLevelTeam () {
                return this.$store.getters.user.unilevelTeam
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../../../../assets/scss/_colors.scss';

    .commissions-total-label{
        padding: 50px 0;
        border-bottom: 6px solid $base1;
    }

    .commissions-total-value{
        p{
            font-size: 44px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/my-team/MyTeamTotal.vue